<template>
    <div class="">
        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title" style="text-align: center">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>行动笔记</span>
                </div>
                <div class="el-radio-group" style="float: right">
                    <label class="el-radio-button red el-radio-button--large">
                        <el-radio v-model="radio_type" label="week" class="el-radio-button__orig-radio"></el-radio>
                        <span class="el-radio-button__inner">周报</span></label>
                    <label class="el-radio-button el-radio-button--large">
                        <el-radio v-model="radio_type" label="month" class="el-radio-button__orig-radio"></el-radio>
                        <span class="el-radio-button__inner">月报</span></label> <label
                        class="el-radio-button el-radio-button--large">
                    <el-radio v-model="radio_type" label="quarter" class="el-radio-button__orig-radio"></el-radio>
                    <span class="el-radio-button__inner">季报</span></label>
                    <label class="el-radio-button el-radio-button--large" style="display: none;">
                        <input type="radio" class="el-radio-button__orig-radio" value="3"><span
                            class="el-radio-button__inner">年报</span></label></div>
            </div>
            <div class="tpl-portlet-content">
                <WeekNotes v-if="radio_type=='week'"></WeekNotes>
                <MonthNotes v-if="radio_type=='month'"></MonthNotes>
                <QuarterNotes v-if="radio_type=='quarter'"></QuarterNotes>
            </div>
        </div>

    </div>
</template>

<script>
    import WeekNotes from '@/apps/plan/mobile_page/week_mobile_notes.vue'
    import MonthNotes from '@/apps/plan/mobile_page/month_mobile_notes.vue'
    import QuarterNotes from '@/apps/plan/mobile_page/quarter_mobile_notes.vue'
    export default {
        name: "planmobilenotes",
        data: function () {
            return {
                show_confirm_dialog: false,
                radio_type: 'week',
                buttons: [],
                noteList: [],
                fetchNoteList: [],

                listIdx: 1,
            }
        },
        components: {
            WeekNotes,
            MonthNotes,
            QuarterNotes
        },
        computed: {
        },
        methods: {
        },
        watch: {
            radio_type: async function (value, oldValue) {

            }
        },
        created() {

        },
        mounted() {
        }
    }
</script>

<style scoped>
    .tpl-portlet-content {
        height: 455px;
        overflow: auto
        /*background: red;*/
    }


    .el-radio-group {
        display: inline-block;
        font-size: 0;
    }

    .el-radio-button {
        height: 30px;
        line-height: 5px;
        position: relative;
        display: inline-block;
    }

    .el-radio-button__orig-radio {
        opacity: 0;
        outline: 0;
        position: absolute;
        z-index: -1;
        left: -999px;
    }

    .el-radio-button__inner {
        line-height: 1;
        vertical-align: middle;
    }

    .el-radio-button__inner {
        position: relative;
        display: inline-block;
    }

    .el-radio-button__inner {
        white-space: nowrap;
        background: #fff;
        border: 1px solid #bfcbd9;
        border-left: 0;
        color: #1f2d3d;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        cursor: pointer;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        padding: 11px;
        font-size: 14px;

    }

    .el-radio-button__inner {
        height: 30px;
        line-height: 5px;
    }

    .el-radio-button__orig-radio[aria-checked=true] + .el-radio-button__inner {
        color: #fff;
        background-color: #20a0ff;
        border-color: #20a0ff;
        box-shadow: -1px 0 0 0 #20a0ff;
    }

    .el-radio-button:first-child .el-radio-button__inner {
        border-left: 1px solid #bfcbd9;
        border-radius: 4px 0 0 4px;
        box-shadow: none !important;
    }
</style>
<style>
.tpl-portlet-components{
  height: calc(100vh);
  padding: 12px 10px 12px;
}
.tpl-portlet-content{
  height: 90% !important;
}
</style>